import installationInstructions from './installationInstructions';

const powerStripCategoryContent = {
  installationInstructions
}

export { powerStripCategoryContent };
